<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes tri-dip-1 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #tri-dip-1 {
    animation-name: tri-dip-1;
  }
  @keyframes tri-dip-2 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #tri-dip-2 {
    animation-name: tri-dip-2;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 423 249.7" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="tri-dip-1">
      <path
        fill="var(--cool500)"
        d="m156 181-8 7a4 4 0 0 0-2 5l8 30c1 3-1 5-2 6s-5-1-6-3l-11-28a4 4 0 0 0-4-3l-59-6-19-2c-2 0-3 0-3 3l-2 21a3 3 0 0 1-2 2c-2 1-4 2-6 1v-2l2-30 2-27-2-7-1-2c3-1 1-3 1-4L2 60l-2-3v-1l29 2 30 3c4 0 7 1 9 5 10 15 18 31 27 47l7 14c0 1 1 2 3 1l41-8-1 6-13 2c-2 1-3 1-2 3l4 19c2 4 2 4 6 3l4-1v9c-1 3 1 5 3 7 5 2 8 5 7 11l2 2Zm-31-26-3-16-2-1-9 2c-2 1-2 1-1 3l7 13h8a3 3 0 0 0 0-1Zm-71 7h-1l-1 16v2c4 0 7 2 11 1l-9-19Zm57 23v1l19 2 1-1a17 17 0 0 0-1-5h-3l-16 3Z"
      />
      <path
        fill="var(--shirt)"
        d="m189 50 13 9c6 5 9 12 11 19 2 5 5 8 9 12l5 4c3 4 7 6 9 10a5 5 0 0 0 3 2 5 5 0 0 1 4 4 9 9 0 0 1-5 2 37 37 0 0 0-17 10c-6 6-10 12-14 19v3c-3 2-3 2-6-1l-15-17h-1c-3-4-5-8-9-11l-8-13c1-2 1-3-1-4a68 68 0 0 0-12-8c-2-1-4 0-6-2 1-8 0-16 3-24a17 17 0 0 1 5-8l11-9c8-3 14 0 21 3Z"
      />
      <path
        fill="var(--flesh)"
        d="M288 148c4 4 8 9 14 11l7 7a26 26 0 0 0 7 7l19 10a108 108 0 0 0 22 10 13 13 0 0 0 3 1c0 2 2 2 3 2 1 1 3 0 3 2a7 7 0 0 1-6 8h-8l-8-4h-4a116 116 0 0 0 13 9c1 1 2 2 3 1a28 28 0 0 0 11 6c3 2 6 2 9 2v5c0 5 1 5 6 4h2v6c-1 2-2 3-4 3a12 12 0 0 1-5-1l-6-2c-10-7-23-9-34-13-10-5-20-8-28-16l-14-12c-7-7-16-13-27-15a3 3 0 0 1 1-2c5-9 10-18 17-27l4-2Z"
      />
      <path
        fill="var(--pants)"
        d="m288 148-4 2c-7 8-12 18-17 27a3 3 0 0 0-1 2l-4 1a8 8 0 0 1-7-3 68 68 0 0 0-23-15c-9-4-18-10-25-18v-3c4-7 8-13 14-19a37 37 0 0 1 17-10 9 9 0 0 0 5-2l8 4a7 7 0 0 1 4 4 10 10 0 0 0 5 5c10 7 19 16 28 25Z"
      />
      <path
        fill="var(--flesh)"
        d="M149 88c2 2 4 1 6 2a68 68 0 0 1 12 8c2 1 2 2 1 4l-6 15-2 6v2l-6 24v6c0 2 1 4 3 4 5 2 9 5 9 11l-1 4a43 43 0 0 1-9 7c-1 0-2 0-2-2 1-6-2-9-7-11-2-2-4-4-3-7v-9a5 5 0 0 0 0-2l1-14v-10l1-6a12 12 0 0 1 1-4c3-7 1-15 1-22l1-6Z"
      />
      <path
        fill="var(--hair)"
        d="m369 235 6 2a12 12 0 0 0 5 1c2 0 4-1 4-3v-6h-2c-5 1-6 1-6-4v-5c1-1 1-3 2-2 3 2 6 0 8 0 7 0 13-2 18-5l8-4 2-2c6-3 10 0 9 6-1 11-7 20-17 25l-17 6c-7 3-16-1-19-7a3 3 0 0 1-1-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M189 50c-7-3-13-6-21-3l-1-4c2-2 3-4 1-7a11 11 0 0 1 0-6c0-2 0-4 3-4a5 5 0 0 1 5 2 46 46 0 0 1 2 5l1 1 1-2-1-7a4 4 0 0 1 1-4c3-3 3-3 0-5a3 3 0 0 1-2-4l3-2h3c3-1 5 1 8 1l2 8v2c0 3 1 5 3 6 2 2 3 3 1 5l-1 2v10c1 2-1 3-3 4l-5 2Z"
      />
      <path
        fill="var(--hair)"
        d="M192 11c-3 0-5-2-8-1h-3l-3 2a3 3 0 0 0 2 4c3 2 3 2 0 5a4 4 0 0 0-1 4l1 7-1 2-1-1a46 46 0 0 0-2-5 5 5 0 0 0-5-2c-3 0-3 2-3 4a11 11 0 0 0 0 6c2 3 1 5-1 7l-3-2a48 48 0 0 1-7-14c-3-9 0-18 10-23a28 28 0 0 1 9-2 67 67 0 0 0 10-2c7-1 9 1 7 8l-1 3Z"
      />
      <path
        fill="var(--cool500)"
        d="m165 174 1-4c0-7-4-9-9-11-2-1-3-2-3-4v-6l10-2 1-1-4-22-1-1 2-6c3-1 4 0 5 3l5 16-1 10c0 3 1 5 4 7 1 1 3 2 2 4-2 3-1 4 1 5l7 27c0 2 0 4-2 4s-3 0-4-2l-7-19c-1-2-2-2-4-1a38 38 0 0 1-3 3Z"
      />
      <path
        fill="var(--hair)"
        d="M352 206h8a7 7 0 0 0 6-8c0-2-2-1-3-2-1 0-3 0-3-2 10 1 17-3 24-9 2-2 3-4 6-4 2-1 4 0 4 3-1 6-2 12-8 17l-18 16a6 6 0 0 1-1 1 28 28 0 0 1-11-6l-4-6Z"
      />
      <path
        fill="var(--flesh)"
        d="M178 162c-2-1-3-2-1-5 1-2-1-3-2-4-3-2-4-4-4-7l1-10 4-21c4 3 6 7 9 11l-5 13c-2 4-1 6 3 8a7 7 0 0 1 0 12c-1 2-3 3-5 3Z"
      />
    </g>
    <g id="tri-dip-2">
      <path
        fill="var(--hair)"
        d="m367 250-8-4c-1-1-3-1-2-3h11c3-2 4-4 3-7-1-2-3-3-6-2-2 2-3 1-4-2l-1-6 1-2c7 0 12-3 17-6a61 61 0 0 0 13-11 20 20 0 0 1 2-2c5-4 9-3 10 3v10a26 26 0 0 1-11 19c-6 5-12 10-21 13Z"
      />
      <path
        fill="var(--cool500)"
        d="M404 217h-1v-9h1ZM156 182l-9 7a3 3 0 0 0-1 4l8 30c1 3 0 5-2 5-3 1-5 0-6-2l-11-29a3 3 0 0 0-3-2l-63-6-17-2c-2 0-2 1-2 2l-1 17-1 3c0 4-3 6-7 5l-1-2 2-30 2-27-2-7c0-1-1-2 1-3l-1-2-20-42L1 59v-2l2-1 44 4 16 1c2 0 3 1 4 3 7 10 13 22 19 33l15 28c2 3 3 4 6 3l16-3c2 2 2 4 3 7a100 100 0 0 0 6 13c2 3 3 8 6 11a20 20 0 0 1 3 9 5 5 0 0 0 3 4c4 1 7 3 8 8 0 4 0 4 4 5Zm-31-27-3-16c0-2-1-1-2-1l-8 2c-3 0-2 1-2 3l6 10c2 5 2 5 8 3l1-1Zm-71 7h-1l-1 16 1 2 8 1c2 1 2 0 1-1l-8-18Zm57 23v1l19 2 1-1v-4c0-1-1-2-2-1l-18 3Z"
      />
      <path
        fill="var(--shirt)"
        d="M150 101a72 72 0 0 1 19-10l10-3a22 22 0 0 1 9 1l6 8 1 1c0 2 1 4 3 4l1-4a3 3 0 0 1 4-2c4 5 4 10 4 16s1 12-1 18l1 3c2 7 4 13 8 18l2 3c2 1 3 3 3 5 0 4-1 5-5 5-3 0-7 1-10 3-8 5-15 12-21 18a11 11 0 0 1-2 2h-3l-2-5c-2-4-4-7-4-11a16 16 0 0 0-3-6 14 14 0 0 1-3-8 36 36 0 0 0-2-7l-1-4-4-18c0-2 1-5-3-3l-2-1a27 27 0 0 0-1-6c-1-5-4-11-4-17Z"
      />
      <path
        fill="var(--flesh)"
        d="m360 226 1 6c1 3 2 4 4 2 3-1 5 0 6 2 1 3 0 5-3 7h-11c-4-3-7-4-11-4a211 211 0 0 1-43-5 54 54 0 0 1-14-5c-9-5-18-11-27-14a34 34 0 0 0-15-3l1-1c5-6 10-12 11-20 0-2 0-3-2-4s-1-1-1-3a25 25 0 0 1 6-6c3 4 8 4 12 5 7 1 13 3 18 7s10 6 15 6l35 5h8l3 1c4 1 5 4 3 7a14 14 0 0 1-12 7l-26-1a4 4 0 0 0 3 2l25 8c3 0 6 2 9 1l1-1 4 1Z"
      />
      <path
        fill="var(--pants)"
        d="M262 178a25 25 0 0 0-6 6l1 3 2 4c-1 8-6 14-11 20l-1 1a53 53 0 0 1-9 7c-3 2-5 2-7 0l-6-6a13 13 0 0 0-9-4 63 63 0 0 1-16-3c-6-3-11-7-15-13a27 27 0 0 0-1-8c6-7 13-13 21-18 3-2 6-3 10-3 4-1 4-1 5-5 5-1 8 0 12 4 1 3 5 3 8 4a140 140 0 0 1 20 9l2 2Z"
      />
      <path
        fill="var(--flesh)"
        d="M150 101c0 6 3 12 4 17a27 27 0 0 1 1 6l-12 3c-4 0-5 2-3 6a145 145 0 0 1 6 16l1 2c1 3 0 6 3 9l5 2c5 2 7 3 7 10l-2 6-4 4c-4-1-4-1-4-5-1-5-4-7-8-8a5 5 0 0 1-3-4 20 20 0 0 0-3-9c-3-3-4-8-6-11a100 100 0 0 1-6-13c-1-3-1-5-3-7-1-6 3-9 7-11a222 222 0 0 1 20-13Z"
      />
      <path
        fill="var(--hair)"
        d="M210 61a18 18 0 0 0-6-2c-3 0-5 2-4 5 1 2 2 4-1 5-3 2-2 5-3 8a10 10 0 0 1 0 2 2 2 0 0 1-2 2l-1-2a51 51 0 0 0 0-5c0-2-1-4-4-4-2 0-3 1-3 3l-1 6a5 5 0 0 1-3 5h-1c-3-7-6-14-6-21 0-6 6-11 11-12 7-1 14 1 21 2h3c1 0 3 0 4 2s0 2-1 4a30 30 0 0 1-3 2ZM357 225l-2 1a131 131 0 0 0-14-9s-2 0 0-1a1 1 0 0 0 1 0h2a14 14 0 0 0 12-7c2-3 1-6-3-7h-3l1-2c10 1 17-3 23-10a13 13 0 0 1 5-4c3-1 5 0 5 3-1 7-2 13-7 17l-20 19Z"
      />
      <path
        fill="var(--cool500)"
        d="m160 178 2-6c0-7-2-8-7-10l-5-2c-3-3-2-6-3-9l14-3c2 0 3-1 3-3l1 5a36 36 0 0 1 2 7 14 14 0 0 0 3 8 16 16 0 0 1 3 6c0 4 2 7 4 11l2 5h3a11 11 0 0 0 2-2 27 27 0 0 1 1 8c-5 1-6-2-7-6l-6-16h-3Z"
      />
      <path
        fill="var(--flesh)"
        d="M212 75c-1-1-2-2-1-3v-6a21 21 0 0 1-1-5 18 18 0 0 0-6-2c-3 0-5 2-4 5 1 2 2 4-1 5-3 2-3 5-3 8a10 10 0 0 1 0 2 2 2 0 0 1-2 2l-1-2a51 51 0 0 0 0-5c-1-2-1-4-4-4-2 0-3 1-3 3l-1 6a5 5 0 0 1-3 5h-1c1 2 0 3-2 4a22 22 0 0 1 9 1l6 8 1 1c0 2 1 4 3 4l1-4a3 3 0 0 1 4-2c3-1 7-1 7-6l1-1a6 6 0 0 0 1-5v-2c4-2 2-4 0-7ZM341 216a1 1 0 0 1 1 0 1 1 0 0 1-1 0Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>